'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = require('./utils/track');

var _track3 = _interopRequireDefault(_track2);

var _events = require('./events');

var _traits = require('./traits');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRODUCT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_TOTAL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number]).isRequired), _propTypes);

function trackUpgradeCompleted() {
    var _ref, _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_ORDER_COMPLETED + ' event');
    return (0, _track3.default)(_events.EVENT_ORDER_COMPLETED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_ORDER_ID, traits[_traits.TRAIT_ORDER_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_TOTAL, traits[_traits.TRAIT_TOTAL]), (0, _defineProperty3.default)(_track, _traits.TRAIT_AFFILIATION, _constants.DEFAULT_AFFILIATION), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCTS, [(_ref = {}, (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRODUCT_ID, traits[_traits.TRAIT_PRODUCT_ID]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_NAME, traits[_traits.TRAIT_NAME]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_CATEGORY, _constants.CATEGORY_UPGRADE), (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRICE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_QUANTITY, 1), _ref)]), _track));
}

exports.default = trackUpgradeCompleted;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/trackUpgradeCompleted.js
// module id = 1400
// module chunks = 1